import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useMemo } from "react";

export const useSkillsType = () => {
  const { customTypes } = useCustomTypes();

  return useMemo(() => customTypes.find(({ name }) => name === "skills"), [customTypes]);
};
